export default class BaseView {
  #resolveContainer(container) {
    if (typeof container === 'string') {
      return document.querySelector(container);
    }
    return container;
  }

  setContent(container, html) {
    const el = this.#resolveContainer(container);
    if (el) {
      el.innerHTML = html;
    }
  }

  showLoading(container, text = 'Memuat...') {
    this.setContent(
      container,
      `<div class="loading-post"><div class="hg-animate" aria-hidden="true"></div><p>${text}</p></div>`
    );
  }

  showEmptyState(container, message) {
    this.setContent(
      container,
      `<div class="empty-state"><span class="material-symbols-rounded" aria-hidden="true">inbox</span><h3>Tidak ada konten</h3><p>${message}</p></div>`
    );
  }

  showAuthRequired(container, message, buttonId = 'login-btn', onLoginClick) {
    this.setContent(
      container,
      `<div class="auth-required"><span class="material-symbols-rounded" aria-hidden="true">login</span><h3>Masuk diperlukan</h3><p>${message}</p><button class="login-btn" id="${buttonId}" aria-label="Masuk sekarang"><span class="material-symbols-rounded" aria-hidden="true">login</span>Masuk Sekarang</button></div>`
    );
    const btn = this.#resolveContainer(container).querySelector(`#${buttonId}`);
    if (btn && onLoginClick) {
      btn.addEventListener('click', onLoginClick);
    }
  }
}

